"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _default2 = exports.default = {
  props: {
    pieData: {
      type: Array,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      timeType: 0,
      dayData: null,
      monthData: null,
      yearData: null,
      pieList: [],
      colorType: '',
      echartfc: '',
      // 图表颜色
      subEchartfc: '',
      // 图表颜色
      zoom: '',
      zoomrAtio: '',
      energyTotal: 0
    };
  },
  watch: {
    timeType: function timeType(val) {
      if (val === 0) {
        this.pieList = this.dayData;
      } else if (val === 1) {
        this.pieList = this.monthData;
      } else {
        this.pieList = this.yearData;
      }
      this.getPieEcharts();
    },
    pieData: function pieData(val) {
      var _this2 = this;
      this.pieList = [];
      val.map(function (e, index) {
        for (var key in val[index]) {
          if (key === "年") {
            _this2.yearData = _this2.changeData(val[index][key]);
          } else if (key === "月") {
            _this2.monthData = _this2.changeData(val[index][key]);
          } else {
            _this2.dayData = _this2.changeData(val[index][key]);
          }
        }
      });
      this.pieList = this.timeType == 0 ? this.dayData : this.timeType == 1 ? this.monthData : this.yearData;
      this.getPieEcharts();
    },
    "$store.state.project.colorType": function $storeStateProjectColorType() {
      this.colorType = this.$store.state.project.colorType;
      if (this.colorType == 'theme_jyh') {
        this.echartfc = '#fff';
        this.subEchartfc = '#e3e3e3';
      } else if (this.colorType == 'theme_ytl') {
        this.echartfc = '#fff';
        this.subEchartfc = '#e3e3e3';
      } else {
        this.echartfc = '#fff';
        this.subEchartfc = '#e3e3e3';
      }
      this.getPieEcharts();
    }
  },
  created: function created() {
    this.colorType = this.$store.state.project.colorType;
    if (this.colorType == 'theme_jyh') {
      this.echartfc = '#fff';
      this.subEchartfc = '#e3e3e3';
    } else if (this.colorType == 'theme_ytl') {
      this.echartfc = '#fff';
      this.subEchartfc = '#e3e3e3';
    } else {
      this.echartfc = '#fff';
      this.subEchartfc = '#e3e3e3';
    }
  },
  mounted: function mounted() {
    // 窗口发生变化从新执行echarts()方法
    var ts = this;
    var resizeOb = new ResizeObserver(function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          ts.$echarts.getInstanceByDom(entry.target).resize();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    resizeOb.observe(document.getElementById('pieCharts'));
  },
  methods: {
    changeData: function changeData(data) {
      var arr = [];
      for (var key in data) {
        for (var i in data[key]) {
          var obj = {
            name: i,
            value: data[key][i][0],
            unit: data[key][i][1]
          };
          arr.push(obj);
        }
      }
      return arr;
    },
    compare: function compare(property, desc) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        if (desc === true) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    getPieEcharts: function getPieEcharts() {
      var _this3 = this;
      var count = 0;
      if (this.timeType == 0) {
        for (var k in this.dayData) {
          count += Number(this.dayData[k].value);
        }
      } else if (this.timeType == 1) {
        for (var _k in this.monthData) {
          count += Number(this.monthData[_k].value);
        }
      } else {
        for (var _k2 in this.yearData) {
          count += Number(this.yearData[_k2].value);
        }
      }
      this.energyTotal = count.toFixed(2);
      var _this = this;
      var pieData = _this.pieList.sort(_this.compare("value", false));
      var pieEcharts = this.$echarts.init(document.getElementById("pieCharts"));
      var option = {
        tooltip: {
          trigger: "item",
          borderWidth: 0,
          formatter: function formatter(param) {
            return "".concat(param.marker).concat(param.name, ": ").concat(param.value.toFixed(2), "kwh, \u5360\u6BD4: ").concat(param.percent, "%");
          },
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 10px rgba(0,120,234,0.1);color:#333333;font-size:16px",
          textStyle: {
            fontSize: 24,
            lineHeight: 50
          },
          padding: [8, 15]
        },
        color: ["#5570c6", "#91cc76", "#fac858", "#ed6666", "#73c0de", "#3ba272", "#fc8352", "#9a61b4", "#ecc49f"],
        legend: {
          type: "plain",
          orient: "vertical",
          icon: "circle",
          show: true,
          y: 'center',
          right: "8%",
          align: 'left',
          itemHeight: 10,
          // itemGap: 4,
          itemGap: 2,
          formatter: function formatter(name) {
            var total = 0;
            var target;
            for (var i = 0, l = _this.pieList.length; i < l; i++) {
              total += _this.pieList[i].value;
              if (_this.pieList[i].name === name) {
                target = _this.pieList[i].value;
              }
            }
            var arr = [];
            if (target === 0) {
              arr = ["{a|" + 0 + "%}", "{b|" + name + "\n}"];
            } else {
              arr = ["{a|" + (target / total * 100).toFixed(2) + "%}", "{b|" + name + "\n}"];
            }
            return arr.join("\n");
          },
          textStyle: {
            color: this.echartfc,
            align: "center",
            rich: {
              a: {
                fontSize: 16,
                lineHeight: 26,
                fontWeight: 400
              },
              b: {
                fontSize: 12,
                color: this.subEchartfc
              }
            }
          }
        },
        title: {
          text: this.energyTotal,
          subtext: "kWh",
          top: "42%",
          left: "34%",
          textAlign: "center",
          textStyle: {
            color: '#fff'
          },
          subtextStyle: {
            color: '#e3e3e3'
          }
        },
        series: [{
          type: "pie",
          radius: ["50%", "70%"],
          center: ["35%", "50%"],
          data: pieData,
          // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
          label: {
            show: false,
            position: "inside",
            formatter: "{b}:{d}%"
          },
          itemStyle: {
            shadowBlur: 10,
            shadowColor: "rgba(9, 45, 97, 0.2)",
            shadowOffsetX: 0,
            shadowOffsetY: 0
          }
        }]
      };
      pieEcharts.setOption(option);
      this.$nextTick(function () {
        _this3.zoom = document.body.style.zoom;
        _this3.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
      });
    }
  }
};